var data, facsimileBundle, first, index, indexed, navigation, next, node, path, prev, sections;

data = require("../json/toc.json");
sections = Object.keys(data);

index = void 0;

indexed = function() {
  var firstAvailableFacsimilesStack, nodePaths, nodes, path, paths, positions, section, sectionData, sectionIndizes, sequence, traverse;
  if (index != null) {
    return index;
  }
  sectionIndizes = (function() {
    var results;
    results = [];
    for (section in data) {
      sectionData = data[section];
      nodes = {};
      sequence = [];
      positions = {};
      paths = [[]];
      nodePaths = {};
      path = [];
      firstAvailableFacsimilesStack = [];
      traverse = function(node, parent = null, nodePath = 0, level = 0) {
        var available, child, contents, f, facsimiles, firstAvailable, i, id, j, len, len1, sig, stackNode;
        ({contents, facsimiles} = node);
        firstAvailableFacsimilesStack.push(node);
        facsimiles = (function() {
          var i, len, results1;
          results1 = [];
          for (i = 0, len = facsimiles.length; i < len; i++) {
            f = facsimiles[i];
            if (nodes[f.id] == null) {
              results1.push(f);
            }
          }
          return results1;
        })();
        firstAvailable = null;
        for (i = 0, len = facsimiles.length; i < len; i++) {
          ({id, available, sig} = facsimiles[i]);
          nodes[id] = {...node, sig};
          nodes[id].parent = parent;
          nodePaths[id] = nodePath;
          if (available) {
            if (firstAvailable == null) {
              while (firstAvailableFacsimilesStack.length > 0) {
                stackNode = firstAvailableFacsimilesStack.pop();
                stackNode.firstAvailableFacsimile = id;
              }
            }
            if (firstAvailable == null) {
              firstAvailable = id;
            }
            positions[id] = sequence.length;
            sequence.push(id);
          }
        }
        node.parent = parent;
        path.push(node);
        paths.push(path.slice(0));
        for (j = 0, len1 = contents.length; j < len1; j++) {
          child = contents[j];
          traverse(child, node, paths.length, level + 1);
        }
        path.pop();
        if (firstAvailable == null) {
          // no available facsimile found for this node
          return firstAvailableFacsimilesStack.pop();
        }
      };
      traverse(sectionData);
      results.push({
        [section]: {nodes, sequence, positions, paths, nodePaths}
      });
    }
    return results;
  })();
  return index = Object.assign({}, ...sectionIndizes);
};

node = function(section, id) {
  return indexed()[section].nodes[id];
};

path = function(section, id) {
  var nodePaths, paths;
  ({nodePaths, paths} = indexed()[section]);
  if (id in nodePaths) {
    return paths[nodePaths[id]];
  } else {
    return void 0;
  }
};

first = function(section) {
  var firstNode, nodes, sequence;
  ({nodes, sequence} = indexed()[section]);
  [firstNode] = sequence;
  return {
    id: firstNode,
    ...nodes[firstNode]
  };
};

next = function(section, id) {
  var nextNode, nodes, position, positions, sequence;
  ({nodes, sequence, positions} = indexed()[section]);
  position = positions[id];
  if ((position == null) || position >= sequence.length - 1) {
    return void 0;
  }
  nextNode = sequence[position + 1];
  return {
    id: nextNode,
    ...nodes[nextNode]
  };
};

prev = function(section, id) {
  var nodes, position, positions, prevNode, sequence;
  ({nodes, sequence, positions} = indexed()[section]);
  position = positions[id];
  if ((position == null) || position <= 0) {
    return void 0;
  }
  prevNode = sequence[position - 1];
  return {
    id: prevNode,
    ...nodes[prevNode]
  };
};

navigation = function(section, id) {
  var nav = {
    path: path(section, id),
    next: next(section, id),
    prev: prev(section, id)
  };

  return nav;
};

facsimileBundle = function(section, id) {
  var targetNode;
  targetNode = node(section, id);
  if (!targetNode) {
    return {
      facsimiles: []
    };
  } else if (targetNode.facsimiles.length > 1) {
    return targetNode;
  } else {
    return targetNode.parent;
  }
};

module.exports = {data, facsimileBundle, sections, node, path, first, next, prev, navigation, indexed};
